<main class="legal-page">
  <section class="legal-hero">
    <div class="container">
      <p>INFORMATIONS LÉGALES</p>
      <h1>Mentions légales</h1>
      <span>Informations relatives à l'édition, à l'hébergement et à l'utilisation du site AGBE.</span>
    </div>
  </section>

  <section class="container legal-content">
    <article>
      <h2>Éditeur du site</h2>
      <p>Le site <strong>agbe-asso.fr</strong> est édité par l'association <strong>AGBE – Amis des Groupes Bibliques à l'Étranger</strong>, association à but non lucratif œuvrant notamment pour l'intégration des Camerounais en France et le soutien de la mission.</p>
      <p>Contact : via la <a routerLink="/contact">page de contact</a> du site.</p>
    </article>

    <article>
      <h2>Responsable de publication</h2>
      <p>Le responsable de publication est le représentant légal de l'association AGBE. Les coordonnées nominatives et administratives complètes de l'association devront être complétées ici depuis les informations officielles de l'association avant mise en production définitive.</p>
    </article>

    <article>
      <h2>Hébergement</h2>
      <p>Le site est hébergé par <strong>Hostinger International Limited</strong>, 61 Lordou Vironos Street, 6023 Larnaca, Chypre.</p>
    </article>

    <article>
      <h2>Propriété intellectuelle</h2>
      <p>Sauf mention contraire, les contenus, textes, éléments graphiques, logos et visuels publiés sur ce site sont protégés par les règles applicables en matière de propriété intellectuelle. Toute reproduction ou réutilisation substantielle nécessite l'autorisation préalable de l'AGBE ou du titulaire des droits concernés.</p>
    </article>

    <article>
      <h2>Données personnelles et formulaires tiers</h2>
      <p>Les formulaires d'adhésion, de don ou d'inscription à certains évènements peuvent être fournis par HelloAsso et intégrés au site. Lorsque vous utilisez ces formulaires, les données saisies sont également soumises aux conditions et politiques de confidentialité de HelloAsso.</p>
      <p>Pour toute demande relative à vos données traitées directement par l'AGBE, utilisez la <a routerLink="/contact">page de contact</a>.</p>
    </article>

    <article>
      <h2>Cookies</h2>
      <p>Le site peut utiliser des cookies strictement nécessaires à son fonctionnement et, selon les services chargés, des cookies ou traceurs tiers. Le bandeau de consentement du site permet de gérer les choix proposés.</p>
    </article>

    <article>
      <h2>Liens externes</h2>
      <p>Le site peut contenir des liens vers des services tiers, notamment HelloAsso. L'AGBE ne contrôle pas le contenu ni les politiques de ces sites externes.</p>
    </article>
  </section>
</main>
